import moment from 'moment';

export const dateFilterParams = {
    debounceMs: 500,
    suppressAndOrCondition: true,
    comparator: function (filterLocalDateAtMidnight, cellValue) {
        if (cellValue == null) {
            return 0;
        }

        const formattedDate = moment(cellValue);
        const year = formattedDate.year();
        const month = formattedDate.month();
        const day = Number(formattedDate.format('DD'));
        let cellDate = new Date(year, month, day);

        if (cellDate < filterLocalDateAtMidnight) {
            return -1;
        } else if (cellDate > filterLocalDateAtMidnight) {
            return 1;
        } else {
            return 0;
        }
    },
};
